// oxlint-disable react/no-array-index-key -- index is the identity
import { styled } from "goober";
import { Fragment, type ReactNode } from "react";

const Dot = styled("span")`
  opacity: 0.5;
  padding: 0 4px;
`;

export function MetaSep() {
  return <Dot>•</Dot>;
}

export const META_SEP = " • ";

export function metaJoin(parts: ReactNode[]): ReactNode {
  return parts.filter(Boolean).map((part, i) => (
    <Fragment key={i}>
      {i > 0 && <MetaSep />}
      {part}
    </Fragment>
  ));
}
